module.exports = __webpack_public_path__ + "img/main.f8f5073d.png";